<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="90" inline>
        <FormItem label="组织名称">
          <Input placeholder="请输入" v-model="table.search.OrganizationName" clearable></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
      </div>
    </div>

    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增组织"
      :footer-hide="true"
      
      :closable="false"
    >
      <organizationadd
        @close="addModal = false"
        @loadData="search"
      ></organizationadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="更新组织"
      :footer-hide="true"
      
      :closable="false"
    >
      <organizationedit
        v-if="editModal"
        :currentData="currentData"
        @close="editModal = false"
        @loadData="search"
      ></organizationedit>
    </Modal>

    <!--分配机构-->
    <Modal
      width="65%"
      v-model="allocationModal"
      title="分配机构"
      :footer-hide="true"
      
      :closable="false"
    >
      <allocation
        :currentData="currentData"
        v-if="allocationModal"
        @close="allocationModal = false"
      ></allocation>
    </Modal>

    <!--详细-->
    <Modal
      v-model="detailModal"
      title="组织详细"
      :footer-hide="true"
      
      :closable="false"
    >
      <organizationdetail
        :currentData="currentData"
        v-if="detailModal"
        @close="detailModal = false"
      ></organizationdetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import organizationadd from "../organization/add.vue";
import organizationedit from "../organization/edit.vue";
import allocation from "../organization/allocation.vue";
import organizationdetail from "../organization/detail.vue";


export default {
  components: {
    DataTable,
    organizationadd,
    organizationedit,
    allocation,
    organizationdetail,
  
  },
  data: function () {
    return {
      detailModal: false,
      currentData: {},
      allocationModal: false,
      editModal: false,
      addModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "组织名称", key: "organizationName" },
          { title: "创建时间", key: "createTime" },
          { title: "创建人", key: "createUser" },
          {
            title: "操作",
            width: "260px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toAllocation(params.row);
                      },
                    },
                  },
                  "分配机构"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.id);
                      },
                    },
                  },
                  "删除"
                ),
               
              ]);
            },
          },
        ],
        apiUrl: "organization/getlist",
        search: {
          OrganizationName: "",
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      //此处特殊处理-深拷贝
      this.currentData = JSON.parse(JSON.stringify(data));
      this.detailModal = true;
    },

    toEdit: function (data) {
      //此处特殊处理-深拷贝
      this.currentData = JSON.parse(JSON.stringify(data));
      this.editModal = true;
    },

    toAllocation: function (data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.allocationModal = true;
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该组织？",
        mask: false,
        onOk: () => {
          this.$api.post(`/organization/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>